import * as actionTypes from 'redux/actions'

const initialState = {
  adminsUpdater: 0,
  loadingAdmins: true
}

const adminsReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_ADMINS_DATA: {
      return {
        ...state,
        adminsListDetails: action.payload.adminsListDetails,
        adminsList: action.payload.adminsList,
        charts: action.payload.adminChartData,
        loadingAdmins: false
      }
    }
    case actionTypes.UPDATE_ADMINS: {
      return {
        ...state,
        adminsUpdater: state.adminsUpdater + 1
      }
    }
    default: {
      return state
    }
  }
}

export default adminsReducer
